import { getOrderIdComments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getOrderCommentsByOrderIdQueryKey = (orderId: number) => {
	return ["ORDER_COMMENTS", orderId];
};

export function useOrderCommentsByOrderIdQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderCommentsByOrderIdQueryKey(orderId),
		queryFn: processResponse(() => getOrderIdComments(orderId)),
		retry: false,
	});
}
